module.exports = __webpack_public_path__ + "media/images/icon_list/grip_horizontal-393a18937bb28a9ebd4cbbaa04f9ed08.svg";